import React, { useEffect, useRef } from 'react';
import '../styles/HCaptcha.css';

// Site key pública do hCaptcha — vem do Amplify Console / .env.
// Se não estiver configurada, o componente não renderiza nada e o fluxo
// segue sem token (o Lambda ainda recusa em produção — falha fechada lá).
export const HCAPTCHA_SITE_KEY = process.env.REACT_APP_HCAPTCHA_SITE_KEY;

// Wrapper leve para o widget do hCaptcha (script carregado em public/index.html).
// Renderização explícita via window.hcaptcha.render — sem libs externas.
export default function HCaptcha({ onVerify, onExpire }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const onVerifyRef = useRef(onVerify);
  const onExpireRef = useRef(onExpire);

  onVerifyRef.current = onVerify;
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (!HCAPTCHA_SITE_KEY) return undefined;

    let cancelled = false;
    let poll = null;

    const render = () => {
      if (
        cancelled ||
        !containerRef.current ||
        widgetIdRef.current !== null ||
        !window.hcaptcha
      ) {
        return;
      }
      widgetIdRef.current = window.hcaptcha.render(containerRef.current, {
        sitekey: HCAPTCHA_SITE_KEY,
        callback: (token) => onVerifyRef.current?.(token),
        'expired-callback': () => onExpireRef.current?.(),
        'error-callback': () => onExpireRef.current?.(),
      });
    };

    if (window.hcaptcha) {
      render();
    } else {
      poll = setInterval(() => {
        if (window.hcaptcha) {
          clearInterval(poll);
          render();
        }
      }, 200);
    }

    return () => {
      cancelled = true;
      if (poll) clearInterval(poll);
      if (widgetIdRef.current !== null && window.hcaptcha?.reset) {
        try {
          window.hcaptcha.reset(widgetIdRef.current);
        } catch {
          /* widget já removido */
        }
      }
    };
  }, []);

  if (!HCAPTCHA_SITE_KEY) return null;
  return <div ref={containerRef} className="hcaptcha-box" />;
}
